import { TransactionChain, useRefresh } from 'services'

// import { ProvidedRequiredArgumentsOnDirectivesRule } from 'graphql/validation/rules/ProvidedRequiredArgumentsRule'
import { useEffect } from 'react'
import { useStore } from './store'
import { useAccount } from 'wagmi'
import { viemPublicClients } from './wallet/chains'
import { DEFAULT_NETWORK } from 'app-constants'
import { sets } from 'abis/set/sets'

export interface BlockInfo {
  data: { [key in TransactionChain]: { chainId: number; blockNumber: number }[] }
}

export function BlockUpdater(): null {
  const { fastRefresh } = useRefresh()
  const { blockNumberInfo, setBlockNumberInfo } = useStore()
  const { address, chain } = useAccount()
  //check if the chainID is in our supported "sets" object
  const isSupportedNetwork = chain && !!sets[chain.id]

  //https://github.com/ethers-io/ethers.js/issues/667

  useEffect(() => {
    const newInfo = { ...blockNumberInfo }

    if (address && isSupportedNetwork) {
      viemPublicClients[chain?.id ?? DEFAULT_NETWORK]
        .getBlockNumber()

        .then((block: bigint) => {
          const blockNumber = Number(block)
          const infoIndex = newInfo.data.eth.findIndex(
            (el: { chainId: string | number; blockNumber: number }) => el.chainId === chain?.id,
          )
          if (infoIndex < 0) {
            newInfo.data.eth = [...newInfo.data.eth, { chainId: Number(chain?.id), blockNumber }]
          } else {
            newInfo.data.eth[infoIndex] = { chainId: Number(chain?.id), blockNumber }
          }
        })
    }

    setBlockNumberInfo(newInfo)
  }, [fastRefresh, address])
  return null
}
